

import RideitPassengerToken from "@/models/Rideit/RideitPassengerToken";
import RideitPassengerTokenCard from './RideitPassengerTokenCard.vue';
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    RideitPassengerTokenCard,
  },
})
export default class RideitPassengerTokenDialog extends Vue {
  @Prop({ required: true}) private value: boolean;
  @Prop({ required: true }) private tokens: RideitPassengerToken[];

  get dialogVisible() {
    return this.value;
  }
  set dialogVisible(newValue: boolean) {
    this.$emit('input', newValue);
  }

  get maxWidth() {
    return this.tokens.length > 1 ? '600px' : '300px';
  }

  closeDialog() {
    this.dialogVisible = false;
  }

  cancelToken(token: RideitPassengerToken) {
    this.$emit('cancel-token', token);
  }

}
